import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {plainToClass, plainToClassFromExist} from 'class-transformer';
import {environment} from '../../../environments/environment';
import {QueryParamsService} from '../../core/services/query-params.service';
import {QueryParamsApiModel} from '../models/query-params-api.model';
import {ResultListApiModel} from '../models/result-list.api.model';
import {ProjectCollaborationAssetApiModel} from '../models/collaboration/project-collaboration-asset.api-model';

@Injectable({
  providedIn: 'root'
})
export class ProjectCollaborationAssetRestService {
  private readonly resource = '/project_collaboration_assets';

  constructor(
    private readonly http: HttpClient,
    private readonly params: QueryParamsService,
  ) {
  }

  public create(payload: any): Observable<ProjectCollaborationAssetApiModel> {
    return this.http.post<ProjectCollaborationAssetApiModel>(environment.apiUrl + this.resource, payload)
      .pipe(map((result) => plainToClass(ProjectCollaborationAssetApiModel, result)));
  }

  public delete(id: string | number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}${this.resource}/${id}`);
  }

  public approve(id: string | number, reviewNote?: string): Observable<ProjectCollaborationAssetApiModel> {
    return this.http.post<ProjectCollaborationAssetApiModel>(`${environment.apiUrl}${this.resource}/${id}/approve`, {reviewNote})
      .pipe(map((result) => plainToClass(ProjectCollaborationAssetApiModel, result)));
  }

  public reject(id: string | number, reviewNote?: string): Observable<ProjectCollaborationAssetApiModel> {
    return this.http.post<ProjectCollaborationAssetApiModel>(`${environment.apiUrl}${this.resource}/${id}/reject`, {reviewNote})
      .pipe(map((result) => plainToClass(ProjectCollaborationAssetApiModel, result)));
  }

  public setCover(id: string | number): Observable<ProjectCollaborationAssetApiModel> {
    return this.http.post<ProjectCollaborationAssetApiModel>(`${environment.apiUrl}${this.resource}/${id}/cover`, {})
      .pipe(map((result) => plainToClass(ProjectCollaborationAssetApiModel, result)));
  }

  public setPostPrimary(id: string | number): Observable<ProjectCollaborationAssetApiModel> {
    return this.http.post<ProjectCollaborationAssetApiModel>(`${environment.apiUrl}${this.resource}/${id}/post-primary`, {})
      .pipe(map((result) => plainToClass(ProjectCollaborationAssetApiModel, result)));
  }

  public getCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ResultListApiModel<ProjectCollaborationAssetApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<ProjectCollaborationAssetApiModel>>(environment.apiUrl + this.resource, {params})
      .pipe(map((result) => plainToClassFromExist(new ResultListApiModel<ProjectCollaborationAssetApiModel>(ProjectCollaborationAssetApiModel), result as object)));
  }

  public getByCollaboration(
    collaborationId: string | number,
    queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()
  ): Observable<ResultListApiModel<ProjectCollaborationAssetApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<ProjectCollaborationAssetApiModel>>(
      `${environment.apiUrl}/project_collaborations/${collaborationId}/assets`,
      {params}
    ).pipe(map((result) => plainToClassFromExist(new ResultListApiModel<ProjectCollaborationAssetApiModel>(ProjectCollaborationAssetApiModel), result as object)));
  }
}
